import axios from 'axios'
const instance = axios.create({ 
//baseURL:   'https://vaccineriskfactor.drugplan.ehealthsask.ca/Api' // Prod 
baseURL:   'https://test.vaccineriskfactor.drugplan.ehealthsask.ca/Api' // Prod 
//baseURL:   'http://localhost:7923/' // Prod 
//baseURL: 'http://172.27.74.31/Api'  // dev
});
export default instance;